import { render, staticRenderFns } from "./Attendances.vue?vue&type=template&id=20019471&scoped=true"
import script from "./Attendances.vue?vue&type=script&lang=js"
export * from "./Attendances.vue?vue&type=script&lang=js"
import style0 from "./Attendances.vue?vue&type=style&index=0&id=20019471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20019471",
  null
  
)

export default component.exports